import { useEffect } from 'react'

/**
 * Points the tile spotlight at the cursor.
 *
 * One delegated listener for the whole document, coalesced into a single
 * rAF, writing two custom properties. No layout thrash beyond one rect
 * read per frame, and it never runs on touch devices.
 */
const useSpotlight = () => {
  useEffect(() => {
    if (!window.matchMedia('(pointer: fine)').matches) return

    let frame = null
    let latest = null

    const apply = () => {
      frame = null
      const { clientX, clientY, target } = latest
      const tile = target instanceof Element && target.closest('.card-x')
      if (!tile) return
      const rect = tile.getBoundingClientRect()
      tile.style.setProperty('--mx', `${clientX - rect.left}px`)
      tile.style.setProperty('--my', `${clientY - rect.top}px`)
    }

    const onMove = (event) => {
      latest = event
      if (frame === null) frame = window.requestAnimationFrame(apply)
    }

    document.addEventListener('pointermove', onMove, { passive: true })

    return () => {
      document.removeEventListener('pointermove', onMove)
      if (frame !== null) window.cancelAnimationFrame(frame)
    }
  }, [])
}

export default useSpotlight
